import { workOrderBusiness } from "api/bussiness/work-order/work-order-bussiness";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import type { AutoCompleteProvider } from "./factory";

const normalizeWorkOrderCustomerId = (
  customerId?: string | number | null,
): string | undefined => {
  if (customerId == null) {
    return undefined;
  }

  const normalizedValue = String(customerId).trim();
  return normalizedValue === "" ? undefined : normalizedValue;
};

export const workOrderAutoCompleteProvider: AutoCompleteProvider = {
  searchOptionItemsAsync: async (keyword, context) => {
    return workOrderBusiness.searchWOAsOptionItems(
      keyword,
      normalizeWorkOrderCustomerId(context?.customerId),
    );
  },
  searchOptionItemsPagedAsync: async (keyword, request, context) => {
    const workOrders = await workOrderBusiness.getLists({
      filter: keyword,
      maxResultCount: request.pageSize,
      skipCount: request.pageIndex * request.pageSize,
      sorting: "",
      customerId: normalizeWorkOrderCustomerId(context?.customerId),
    });

    return {
      items: mapToDistinctOptionItems(
        workOrders.items,
        (item) => item.id,
        (item) => item.woNumber,
      ),
      totalCount: workOrders.totalCount,
    };
  },
  resolveSelectedOptionAsync: async (value) => {
    const normalizedId = String(value ?? "").trim();
    if (!normalizedId) {
      return null;
    }

    try {
      const workOrder = await workOrderBusiness.getById(normalizedId);
      if (!workOrder?.id) {
        return null;
      }

      return {
        value: workOrder.id,
        label: workOrder.woNumber || normalizedId,
      };
    } catch {
      return null;
    }
  },
};
